import { useConversations, useCurrentUser } from '@centecomm/portal-service-react';
import hubConnectionThunk from 'State/middleware/hubConnectionThunk';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const ConversationHub = ({ token }: { token: string }): React.ReactElement => {
    const dispatch = useDispatch();
    const { currentUser } = useCurrentUser();
    const { getConversation, getConversationParticipant } = useConversations();

    useEffect(() => {
        if (token) dispatch(hubConnectionThunk(token, currentUser, getConversation, getConversationParticipant));
    }, [token]);

    return <></>;
};

export default ConversationHub;
